import { API_URLs } from "../../../../utilities/API_URLs";
import iAxios from "../../../../utilities/axios/axios-setup";
import { Http } from "../../../../utilities/axios/http";
import { EmployeePageState, NewEmployeeRequest } from "./_model";

export const postNewEmployee = (data: NewEmployeeRequest) => {
  return iAxios
    .post(API_URLs.staff.postStaff, data)
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export const getEmployeeList = (pageState: EmployeePageState) => {
  const obj: any = { ...pageState, order: null };
  Object.keys(pageState).forEach((key: any) => {
    if (key === "order") {
      console.log("The order key ");
      obj["order[" + (pageState?.order?.dataKey ?? "") + "]"] =
        pageState?.order?.order;
    } else {
      obj[key] = obj[key]?.toString();
    }
  });
  delete obj["order"];
  console.log("List page state : ", obj);
  return iAxios
    .get(API_URLs.staff.getStaff + "?" + new URLSearchParams(obj))
    .then((r) => {
      return r?.data;
    })
    .catch((e) => {
      return null;
    });
};

export const getEmployeeById = (id: string) => {
  return iAxios
    .get(API_URLs.staff.getStaffById?.replace("{id}", id))
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export const deleteEmployeeById = (id: string) => {
  return iAxios
    .delete(API_URLs.staff.deleteStaffById?.replace("{id}", id))
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export const patchEmployeeById = (id: string, data: NewEmployeeRequest) => {
  return iAxios
    .patch(
      API_URLs.staff.patchStaffById?.replace("{id}", id),
      { ...data, id },
      {
        headers: {
          "Content-Type": "application/merge-patch+json",
        },
      }
    )
    .then((r) => {
      return r.data;
    })
    .catch((e) => {
      return null;
    });
};

export const getAllStaff = async (params?: any) => {
  try {
    return await Http.get(API_URLs.staff.getStaff, params);
  } catch (error) {
    return error;
  }
};

export class StaffService {
  static createStaff = async (data: any) => {
    try {
      return await Http.post(API_URLs.staff.postStaff, data);
    } catch (error) {
      return error;
    }
  };

  static getStaffForSelect = async (params: any) => {
    try {
      return await Http.get(API_URLs.staff.getStaffForSelect, params);
    } catch (error) {
      return error;
    }
  };

  static updateStaff = async (data: any) => {
    try {
      return await Http.patch(API_URLs.staff.postStaff, data);
    } catch (error) {
      return error;
    }
  };

  static getOneStaff = async (id: number) => {
    try {
      return await Http.getOne(API_URLs.staff.getStaff, id);
    } catch (error) {
      return error;
    }
  };
}
